import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Title } from '../../../../../components/typography/Heading';
import ThemeContainer from '../../../../../components/theme-container/ThemeContainer';

import styles from './SelectedSchoolWithProjects.module.less';

const SelectedSchool = ({ school, type, selectSchoolCallback }) => {
    const [schoolData, setSchoolData] = useState(school);
    const baseUrl = useSelector((state) => state.baseURL);

    const fetchSchool = useCallback(
        async (organizationNumber) => {
            const results = await fetch(`${baseUrl}/api/public/school/${organizationNumber}?type=${type}`);

            if (results.ok) {
                const result = await results.json();
                setSchoolData(result?.school);
                selectSchoolCallback({ school: result?.school });
            } else {
                setSchoolData({});
            }
        },
        [baseUrl]
    );

    useEffect(() => {
        if (school?.organizationNumber) {
            fetchSchool(school.organizationNumber);
        }
    }, [fetchSchool, school.organizationNumber]);

    if (!schoolData?.name) {
        return null;
    }

    return (
        <ThemeContainer className={styles.selectedSchool}>
            <Title tag={'h3'}>{schoolData.name}</Title>

            {schoolData.address && (
                <address className={styles.schoolInformation}>
                    <p className={styles.addressLine}>{schoolData.address.address}</p>
                    <p className={styles.addressLine}>
                        {schoolData.address.postalCode} {schoolData.address.postalName}
                    </p>
                </address>
            )}
        </ThemeContainer>
    );
};

export default SelectedSchool;
